import * as React from 'react'
import classNames from 'classnames'
import Logo from '../../../assets/imgs/logo.svg'
import './styles.css'
import BookADemoButton from '../../ui/BookADemoButton'
import { Link, NavLink, useLocation } from 'react-router-dom'

const TALENT_ORGANIZATION_PATHS = ['/rpo', '/staffing', '/agencies']
const EU_NAVIGATION = [
  ['Platform', '#platform'],
  ['Public Sector', '#public-sector'],
  ['Evidence', '#evidence'],
  ['Trust & IP', '#trust'],
  ['Services', '#services'],
  ['Contact', '/contact'],
]

const EUHeader = () => {
  const [open, setOpen] = React.useState(false)
  const location = useLocation()
  const burgerClassName = classNames('burger', { open })
  const navClassName = classNames('menu', { open })
  const overlayClassName = classNames('overlay', { open })
  const closeMenu = () => setOpen(false)

  return (
    <>
      <header>
        <div className='box'>
          <div className='header-content-bg' />
          <div className='header-content'>
            <Link className='header-logo' to='/'>
              <img src={Logo} alt='Pod' />
            </Link>
            <div className='nav-menu'>
              <div className='menu-desktop'>
                {EU_NAVIGATION.map(([label, href]) => {
                  const resolvedHref = href.startsWith('#') && location.pathname !== '/' ? `/${href}` : href
                  return <a key={href} href={resolvedHref}>{label}</a>
                })}
              </div>
              <div className='mobile-book-demo'><BookADemoButton /></div>
              <button className={burgerClassName} onClick={() => setOpen(!open)} aria-label='Toggle navigation'>
                <div className='line' /><div className='line' /><div className='line' />
              </button>
              <nav className={navClassName}>
                {EU_NAVIGATION.map(([label, href]) => {
                  const resolvedHref = href.startsWith('#') && location.pathname !== '/' ? `/${href}` : href
                  return <a key={href} href={resolvedHref} onClick={closeMenu}>{label}</a>
                })}
              </nav>
            </div>
            <div className='desktop-book-demo'><BookADemoButton /></div>
          </div>
        </div>
      </header>
      <div className={overlayClassName} onClick={closeMenu} />
    </>
  )
}

const Header = ({ currentPage, isEu = false }) => {
  const [open, setOpen] = React.useState(false)
  const location = useLocation()

  React.useLayoutEffect(() => {
    const updateSize = () => {
      if (window.innerWidth > 750 && open) {
        setOpen(false)
      }
    }

    window.addEventListener('resize', updateSize)

    return () => window.removeEventListener('resize', updateSize)
  }, [open])

  if (isEu) return <EUHeader />

  const burgerClassName = classNames('burger', { open: open })
  const navClassName = classNames('menu', { open: open })
  const overlayClassName = classNames('overlay', { open: open })
  const talentOrganizationsClassName = classNames('talent-organizations-link', {
    'active-link': TALENT_ORGANIZATION_PATHS.includes(location.pathname),
  })
  const isSkillBridgePage = location.pathname === '/skillbridge'

  const closeMenu = () => {
    setOpen(false)
  }

  return (
    <>
      <header>
        <div className='box'>
          <div className='header-content-bg' />
          <div className='header-content'>
            <Link className='header-logo' to='/'>
              <img src={Logo} alt='Logo' />
            </Link>
            <div className='nav-menu'>
              <div className='menu-desktop'>
                {!isSkillBridgePage && <>
                  <NavLink
                    to='/enterprise'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Enterprise
                  </NavLink>
                  <NavLink
                    to='/platform-architecture'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Platform
                  </NavLink>
                  <div className='talent-organizations'>
                    <p className={talentOrganizationsClassName}>Talent Organizations</p>
                    <div className='talent-organizations-dropdown'>
                      <NavLink
                        to='/rpo'
                        viewTransition
                        onClick={closeMenu}
                        className={({ isActive }) =>
                          isActive ? 'active-link' : undefined
                        }
                      >
                        RPO
                      </NavLink>
                      <NavLink
                        to='/staffing'
                        viewTransition
                        onClick={closeMenu}
                        className={({ isActive }) =>
                          isActive ? 'active-link' : undefined
                        }
                      >
                        Staffing Firms
                      </NavLink>
                      <NavLink
                        to='/agencies'
                        viewTransition
                        onClick={closeMenu}
                        className={({ isActive }) =>
                          isActive ? 'active-link' : undefined
                        }
                      >
                        Workforce Agencies
                      </NavLink>
                    </div>
                  </div>
                </>}
                <NavLink
                  to='/skillbridge'
                  viewTransition
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    isActive ? 'active-link' : undefined
                  }
                >
                  SkillBridge
                </NavLink>
                {!isSkillBridgePage && <>
                  <NavLink to='/#our-clients' viewTransition onClick={closeMenu}>
                    Clients
                  </NavLink>
                  <NavLink
                    to='/research'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Innovations
                  </NavLink>
                </>}
                <NavLink
                  to='/contact'
                  viewTransition
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    isActive ? 'active-link' : undefined
                  }
                >
                  Contact
                </NavLink>
              </div>
              <div className='mobile-book-demo'>
                <BookADemoButton />
              </div>
              <button
                className={burgerClassName}
                onClick={() => setOpen(!open)}
              >
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </button>
              <nav className={navClassName}>
                {!isSkillBridgePage && <>
                  <NavLink
                    to='/enterprise'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Enterprise
                  </NavLink>
                  <NavLink
                    to='/platform-architecture'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Platform
                  </NavLink>
                  <p className={talentOrganizationsClassName}>Talent Organizations</p>
                  <NavLink
                    to='/rpo'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link submenu-link' : 'submenu-link'
                    }
                  >
                    RPO
                  </NavLink>
                  <NavLink
                    to='/staffing'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link submenu-link' : 'submenu-link'
                    }
                  >
                    Staffing Firms
                  </NavLink>
                  <NavLink
                    to='/agencies'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link submenu-link' : 'submenu-link'
                    }
                  >
                    Workforce Agencies
                  </NavLink>
                </>}
                <NavLink
                  to='/skillbridge'
                  viewTransition
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    isActive ? 'active-link' : undefined
                  }
                >
                  SkillBridge
                </NavLink>
                {!isSkillBridgePage && <>
                  <NavLink to='/#our-clients' viewTransition onClick={closeMenu}>
                    Clients
                  </NavLink>
                  <NavLink
                    to='/research'
                    viewTransition
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      isActive ? 'active-link' : undefined
                    }
                  >
                    Innovations
                  </NavLink>
                </>}
                <NavLink
                  to='/contact'
                  viewTransition
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    isActive ? 'active-link' : undefined
                  }
                >
                  Contact
                </NavLink>
              </nav>
            </div>
            <div className='desktop-book-demo'>
              <BookADemoButton />
            </div>
          </div>
        </div>
      </header>
      <div
        className={overlayClassName}
        onClick={() => {
          setOpen(false)
        }}
      />
    </>
  )
}

export default Header
